import { DCUIContent } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { DCUIThemingCaptureStepValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";

export const getDCUIThemingCaptureStepValidationErrors = (
    documentCaptureStep: DCUIThemingStep,
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    dcuiContent: DCUIContent,
): DCUIThemingCaptureStepValidationErrors => {
    let count = 0;
    let titleError = null;
    let instructionsError = null;
    let screenOrientationPreviewTextError = null;
    let customMediaURLError = null;
    let captureButtonLabelError = null;

    const stepType = documentCaptureStep.stepType;

    if (isUsingDCUIVersion2 && hasDisplayableDocumentCaptureAttributes) {
        if (!dcuiContent[stepType].label) {
            count += 1;
            titleError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent[stepType].instructionsHtml) {
            count += 1;
            instructionsError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (dcuiContent[stepType].showScreenOrientationPreview && !dcuiContent[stepType].screenOrientationPreviewText) {
            count += 1;
            screenOrientationPreviewTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (dcuiContent[stepType].useCustomScreenOrientationVideo && !dcuiContent[stepType].screenOrientationMediaUrl) {
            count += 1;
            customMediaURLError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (!dcuiContent[stepType].nativeCameraButtonText) {
            count += 1;
            captureButtonLabelError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
    }

    return {
        titleError,
        instructionsError,
        screenOrientationPreviewTextError,
        customMediaURLError,
        captureButtonLabelError,
        count: count,
        tabTitle: <TabTitleWithErrorCount tabName={documentCaptureStep.stepResources.tabName} errorCount={count} />
    };
};